/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function scrollTo(element, to, duration) {
    const el = element;
    if (duration <= 0) return;
    const difference = to - element.scrollTop;
    const perTick = (difference / duration) * 10;

    setTimeout(() => {
        el.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
}
